import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { DemoAccountService } from 'src/shared/services/demo-account.service';
import { AccountManagerService } from 'src/shared/services/account-manager.service';
import { Util } from 'src/shared/util/util';

/**
 * Small centered modal (dialog smallDisplay mode) opened from the Account Manager
 * button on the floating onboarding pill. Introduces the user's account manager
 * with call / text / schedule actions.
 */
@Component({
  selector: 'account-manager-modal',
  templateUrl: './account-manager-modal.component.html',
  styleUrls: ['./account-manager-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class AccountManagerModalComponent implements OnInit {

  data: any;

  // The customer's assigned account manager (from /me), or TIDY's default until one is set.
  managerName = AccountManagerService.DEFAULT.name;
  managerPhoto = AccountManagerService.DEFAULT.photoUrl;
  managerEmail = AccountManagerService.DEFAULT.email;
  managerPhone = AccountManagerService.DEFAULT.phone;

  private rightSidePanelService = inject(RightSidePanelService);
  private accountManagerService = inject(AccountManagerService);
  private cdr = inject(ChangeDetectorRef);
  private util = inject(Util);

  async ngOnInit(): Promise<void> {
    this.rightSidePanelService.setDialogPageTitle('Your Account Manager');
    const manager = await this.accountManagerService.getDisplay();
    this.managerName = manager.name;
    this.managerPhoto = manager.photoUrl;
    this.managerEmail = manager.email;
    this.managerPhone = manager.phone;
    this.cdr.markForCheck();
  }

  email = () => {
    window.location.href = `mailto:${this.managerEmail}`;
  };

  text = () => {
    window.location.href = `sms:${this.managerPhone}`;
  };

  schedule = () => {
    this.util.openUrl(DemoAccountService.SCHEDULE_CALL_URL);
  };
}
